<div class="m-nexpe">
  <header class="m-nexpe__header">
    <div class="m-nexpe__headerContent">
      <div class="m-nexpe__headerText">
        <h2 class="m-nexpe__title">{{ 'NEXPE.TITLE' | translate }}</h2>
        <p class="m-nexpe__subtitle">{{ 'NEXPE.SUBTITLE' | translate }}</p>
      </div>
      <button type="button" class="m-nexpe__addBtn" (click)="onAddNExpe()">
        {{ 'NEXPE.ADD_NEW' | translate }}
      </button>
    </div>
  </header>

  @if (isLoading()) {
  <div class="m-nexpe__loading">
    <p>{{ 'COMMON.LOADING' | translate }}</p>
  </div>
  } @if (error()) {
  <div class="m-nexpe__error">
    <p>{{ 'COMMON.ERROR' | translate }}</p>
  </div>
  } @if (!isLoading() && !error()) {
  <div class="m-nexpe__content">
    <app-nexpe-search-bar (searchChange)="onSearchChange($event)" />

    <app-nexpe-table [nexpes]="filteredNexpeData()" (rowClick)="onRowClick($event)" />

    <app-nexpe-detail-modal
      [nexpe]="currentNExpe()"
      [isOpen]="modalOpen()"
      [isEditMode]="isEditMode()"
      (modalClose)="onModalClose()"
      (save)="onModalSave()"
      (delete)="onDeleteNExpe($event)"
      (configChange)="onConfigChange($event)"
    />
  </div>
  }

  <app-delete-confirmation-modal
    [isOpen]="showDeleteModal()"
    [title]="'COMMON.DELETE_MODAL.TITLE' | translate"
    [message]="'COMMON.DELETE_MODAL.MESSAGE' | translate"
    [itemName]="nexpeToDelete()?.nexpe"
    [confirmLabel]="'COMMON.DELETE_MODAL.CONFIRM' | translate"
    [cancelLabel]="'COMMON.DELETE_MODAL.CANCEL' | translate"
    [deletingLabel]="'COMMON.DELETE_MODAL.DELETING' | translate"
    [isDeleting]="isLoading()"
    (confirmed)="onConfirmDelete()"
    (cancelled)="onCancelDelete()"
  />
</div>
